import React, { useState } from "react";
import RegionTree from "../RegionManagement/RegionList/RegionTree/RegionTree";
import "./Region.css";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { MapPin } from "lucide-react";

const RegionManagement = () => {
  const { t } = useTranslation();
  const [treeView, setTreeView] = useState("grid");
  const [selectedValue, setSelectedValue] = useState("grid");

  function refreshRegionList(msg) {
    toast.success(msg, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000, // Close after 2 seconds
    });
    setTreeView("grid");
  }

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 14px",
          borderRadius: "10px",
          background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
          boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
        }}
      >
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            background: "rgba(255,255,255,0.16)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <MapPin size={14} color="#fff" />
        </div>
        <div>
          <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
            {t("region_management_header")}
          </div>
          <div style={{ fontSize: "10.5px", color: "rgba(255,255,255,0.75)", marginTop: "1px" }}>
            Manage regions, districts, and sub-regions
          </div>
        </div>
      </div>
      <div className="region_container" style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
        <RegionTree refreshRegionList={refreshRegionList} />
      </div>
    </div>
  );
};

export default RegionManagement;
